import script from "./TrainingCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingCategory.vue?vue&type=script&setup=true&lang=js"

import "./TrainingCategory.vue?vue&type=style&index=0&id=d44e3106&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d44e3106"]])

export default __exports__